import { getSessionId } from './session';

const API = `${(process.env.CRA_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL)}/api`;

/**
 * Fire-and-forget `nav_click` analytics ping.
 * Payload mirrors AnalyticsEventIn so the same endpoint handles pageviews + clicks.
 *
 * @param {Object} p
 * @param {string} p.slug   Namespaced slug, e.g. "systems:solutions:managed-it-services"
 * @param {string} [p.label] Human-readable label shown in admin
 */
export function trackNavClick({ slug, label }) {
  if (!slug) return;
  try {
    const body = JSON.stringify({
      session_id: getSessionId(),
      path: window.location.pathname,
      event_type: 'nav_click',
      item_slug: slug,
      item_label: label || slug,
    });

    // Prefer sendBeacon so the request survives the page navigation triggered
    // by the <Link>'s click right after this call.
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(`${API}/analytics/track`, blob)) return;
    }

    fetch(`${API}/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics must never break the UI */
  }
}
